<template>
  <div id="TranshipmentEvaluationsView">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card>
        <v-card-text class="pa-0 ma-0">
          <div class="text-center">
            <h1 class="py-5">Avaliações do Transbordo</h1>
          </div>

          <div v-if="isLoading" class="d-flex my-6 justify-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div
            v-else
            v-for="(evaluation, index) in evaluations"
            :key="index"
            :class="`px-4 py-2${index % 2 !== 1 ? ' evaluation-secondary' : ''}`"
          >
            <div class="mb-2 d-flex justify-space-between align-center">
              <span class="body-2 font-weight-medium">{{ formatCreatedAt(evaluation.createdAt) }}</span>
              <div class="d-flex align-center">
                <span @click="expand(evaluation)">
                  <v-icon
                    :class="`${!evaluation.expanded ? 'expanded-section' : ''} mr-1 cursor-pointer`"
                    :color="evaluation.expanded ? 'primary' : ''"
                    >mdi-chevron-up</v-icon
                  >
                </span>
                <span>
                  <v-chip
                    v-if="evaluation.readingDate === '0001-01-01T00:00:00'"
                    class="px-4"
                    color="red"
                    text-color="white"
                    x-small
                  >
                    Não lida
                  </v-chip>
                  <v-chip v-else class="px-4" color="green" text-color="white" x-small> Lida </v-chip>
                </span>
              </div>
            </div>
            <div :class="!evaluation.expanded ? 'text-truncate' : ''">
              {{ evaluation.evaluation }}
            </div>
          </div>
          <div v-if="totalRecords !== null && totalRecords > 5" class="d-flex justify-center mt-4">
            <v-pagination v-model="pagination.pageNumber" :length="totalPages" :total-visible="7"></v-pagination>
          </div>
        </v-card-text>

        <v-card-actions class="d-flex justify-space-between py-5">
          <v-btn color="info" class="flex-grow-1" large @click="close()"> VOLTAR </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';

export default {
  name: 'TranshipmentEvaluationsView',
  props: {
    open: {
      default: () => false,
      type: Boolean
    },
    transhipmentId: {
      default: null,
      type: String
    }
  },
  data: () => ({
    isLoading: true,
    evaluationOpened: false,
    evaluationView: false,
    evaluations: [],

    pagination: {
      pageNumber: 1
    },
    totalRecords: null,
    totalPages: null
  }),

  watch: {
    open: {
      handler(isOpen) {
        if (isOpen) this.fetchTranshipmentEvaluations();
      }
    },

    'pagination.pageNumber': {
      handler(pageNumber) {
        this.fetchTranshipmentEvaluations({ transhipmentId: this.transhipmentId, pageSize: 5, pageNumber });
      }
    }
  },

  methods: {
    ...mapActions('TranshipmentStore', ['getTranshipmentsEvaluationsByTranshipmentId']),

    async fetchTranshipmentEvaluations(params = { transhipmentId: this.transhipmentId, pageSize: 5, pageNumber: 1 }) {
      try {
        this.isLoading = true;
        const { data, totalRecords, totalPages } = await this.getTranshipmentsEvaluationsByTranshipmentId(params);
        this.evaluations = data.map((evaluation) => {
          return { ...evaluation, expanded: false };
        });
        this.totalRecords = totalRecords;
        this.totalPages = totalPages;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    formatCreatedAt(date) {
      return format(new Date(date), 'PPP', { locale: pt });
    },

    expand(item) {
      item.expanded = !item.expanded;
    },
    close() {
      this.$emit('closeEvaluations');
      this.evaluations = [];
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
